import innerHTML from 'utils/DOM/innerHTML'
import toggleClass from 'utils/DOM/toggleClass'
import getAgentsAvailability from 'core/services/getAgentsAvailability'
const NONE_CLASS = 'd-none'

async function showAgentsAvailable(state_acronym) {
  if (state_acronym) {
    const agentsObject = await getAgentsAvailability(state_acronym)
    if (!Array.isArray(agentsObject)) {
      return
    }
    if (
      agentsObject.length > 0 &&
      agentsObject[0].agentsAvailable &&
      agentsObject[0].agentsAvailable > 0
    ) {
      innerHTML('.js_agents', agentsObject[0].agentsAvailable)
      toggleClass('.agent-no-available', NONE_CLASS, true)
      toggleClass('.Header__agent', NONE_CLASS, false)
    }
  }
}

export default showAgentsAvailable
